import { messagesForParent } from '@b2ag/micro-front-tools'
import type { DataForParent } from '@b2ag/micro-front-tools'
import type { Router } from 'vue-router'

function callbackCurrentProfile(router: Router) {
  router.push({ path: '/' })
}

export function callbacksFromCurrentProfileMicroFrontIframe(data: DataForParent, router: Router) {
  switch (data.message) {
    case messagesForParent.CURRENT_PROFILE_SELECTED:
      callbackCurrentProfile(router)
      break
    default:
      break
  }
}
